import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型
import { SettleAccountDetail } from '../../service/class/SettleAccountDetail';

// 借助 createSlice 创建 reducer、action
const SettleAccountDetailSlice = createSlice({
    name: 'settleAccountDetail',
    initialState: {
        value: new SettleAccountDetail(),
    },
    reducers: {
        setSettleAccountDetail: (state, action: PayloadAction<SettleAccountDetail>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setSettleAccountDetail } = SettleAccountDetailSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const settleAccountDetailSelector = (state: RootState) => state.settleAccountDetail.value;

// Reducer，真正执行修改 state 的纯函数
export default SettleAccountDetailSlice.reducer;
